<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="ch3" title="Do People Really Turn Green with Envy?">
<p class="h2a"><a href="#/text/Contents#rch3">Do People Really Turn Green with Envy?</a></p>
<p class="noindent1">Generally seen as something negative, envy is an emotion that occurs when a person desires another’s superior possessions, achievements, or qualities, or wishes that the other person didn’t have them. Thought to be one of the main causes of unhappiness in people, envy is often associated with the color green. But do people actually turn green with envy? How did this idea come about?</p>
<p class="indent">The idea of turning green with envy began in ancient Greece. The Greeks believed that various illnesses, along with what they termed “restless emotions,” were accompanied by an overproduction of bile, which lent a pallid green color to a person’s complexion. In the 7th century, the Greek poet Sappho described a stricken lover as being “green.”</p>
<p class="indent">This idea persisted through the ages and was eventually brought to the mainstream by Shakespeare, who popularized the concept in two of his works. In his 1603 play <i>Othello</i>, he wrote, “Beware my lord of jealously. It is the green-eyed monster which doth mock the meat it feeds on.” He made further reference in his 1605 play <i>The Merchant of Venice</i>, when he wrote, “How all the other passions fleet to air, as doubtful thoughts and rash-embraced despair and shuddering fear and green-eyed jealousy!”</p>
<p class="indent"><span class="right_1" epub:type="pagebreak" id="page_10" title="10">So while the Greeks actually believed that green-eyed monsters existed, they don’t. It was, in fact, Shakespeare who perpetuated the myth of turning green with envy and turned it into the expression that is still used today.</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter003.vue?e967a848